import { Input, message, Modal } from "antd";
import { useState } from "react";

interface Props {
    title?: string;
    name: string;
    item: any;
    onCancel: () => void;
    onSuccess: () => void;
    api: any;
}
const DeleteModal = (props: Props) => {
    const { item, onSuccess, title = "item", name, } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [value, setValue] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);

    const onSubmit = () => {
        if (!value) {
            messageApi.warning("Enter confirm text");
            return;
        }
        if (value === name) {
            setSubmitLoading(true);
            props.api(item?.id).then((res: any) => {
                onSuccess();
                setSubmitLoading(false);
            }).catch((err: any) => {
                setSubmitLoading(false);
                console.error('err', err);
            })
        } else {
            messageApi.warning("Confirm text is not matched!");
        }

    }

    const onCancel = () => {
        props?.onCancel();
        setValue("")
    }

    return (
        <Modal
            width={400}
            open={Object.keys(item).length > 0}
            onCancel={() => onCancel()}
            onOk={() => onSubmit()}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0",
                body: "!p-[20px] !border-b !border-[#E4E7EC]",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            title={(
                <p className="m-0 font-[500]">
                    ⚠ Delete {title}
                </p>
            )}
            okText={`Delete ${title}`}
            okButtonProps={{
                danger: true,
                loading: submitLoading
            }}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
        >
            <div>
                {contextHolder}
                <p>Are you sure you want to permanently delete the brand <strong>{name}</strong>?
                    <br /><br />
                    ove all brand information, files, product lists, and associated data from the system.
                    <br /><br />
                    ⚠ This action cannot be undone.
                    To confirm, please type the {title?.toLowerCase()}'s name below:
                </p>
                <Input
                    type="text"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={`Enter ${title?.toLowerCase()}'s name`}
                />
            </div>
        </Modal>
    )
}

export default DeleteModal